export enum ReactionStyleVariant {
  primary = 'primary',
  secondary = 'secondary',
}
